// Skeleton de filas para las tablas de listado.
// Muestra placeholders con "shimmer" (tw-animate-pulse) mientras llega la data, para que NO se
// vea el salto de "tabla vacía → aparecen las filas" de golpe. Se renderiza dentro de <tbody>,
// en lugar del spinner. El contenido real luego entra con un fade-in (clase .tabla-fade-in).
interface TablaSkeletonProps {
  /** Filas placeholder a mostrar. */
  rows?: number;
  /** Columnas (aprox. las de la tabla; no necesita ser exacto). */
  cols?: number;
}

export const TablaSkeleton = ({ rows = 6, cols = 5 }: TablaSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={`sk-${r}`} aria-hidden="true">
          {Array.from({ length: cols }).map((_, c) => (
            <td key={`sk-${r}-${c}`} className="tw-py-3 tw-px-2">
              <div
                className="tw-h-4 tw-w-full tw-rounded tw-bg-gray-200 tw-animate-pulse"
                // Ligero desfase por fila → efecto de onda, más agradable que todo a la vez.
                style={{ animationDelay: `${(r % 6) * 90}ms` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TablaSkeleton;
